import { render } from "./ViewTerms.vue?vue&type=template&id=c96f94c0&scoped=true"
import script from "./ViewTerms.vue?vue&type=script&lang=js"
export * from "./ViewTerms.vue?vue&type=script&lang=js"

import "./ViewTerms.vue?vue&type=style&index=0&id=c96f94c0&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96f94c0"]])

export default __exports__